import React, { ButtonHTMLAttributes } from "react";
import "./Button.css";

export type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "danger" | "glass";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

export default function Button({
  children,
  className = "",
  variant = "primary",
  size = "md",
  isLoading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  disabled,
  type = "button", // Default to button to prevent accidental form submits
  ...props
}: ButtonProps) {
  
  const baseClass = `btn btn-${variant} btn-${size}`;
  const widthClass = fullWidth ? "btn-full" : "";
  const loadingClass = isLoading ? "btn-loading" : "";
  const combinedClasses = `${baseClass} ${widthClass} ${loadingClass} ${className}`.trim();

  return (
    <button
      type={type}
      className={combinedClasses}
      disabled={disabled || isLoading}
      aria-disabled={disabled || isLoading}
      aria-live="polite"
      {...props}
    >
      {isLoading && (
        <span className="btn-spinner" aria-hidden="true" />
      )}
      
      {!isLoading && leftIcon && (
        <span className="btn-icon-left">{leftIcon}</span>
      )}
      
      <span className="btn-label">{children}</span>
      
      {!isLoading && rightIcon && (
        <span className="btn-icon-right">{rightIcon}</span>
      )}
    </button>
  );
}